import { Link } from "react-router-dom";
import { HEADER_CONFIG } from "@/src_new/shared/config/header.config";
import { WHITE_LABEL_CONFIG, isImageLogoPath } from "@/src_new/whiteLabel";

type Props = {
  className?: string;
  imageClassName?: string;
  textClassName?: string;
};

export default function BrandLogo({
  className = "flex flex-col leading-tight",
  imageClassName = "h-12 w-auto object-contain",
  textClassName = "text-2xl font-extrabold tracking-tight text-theme-text",
}: Props) {
  const { brand } = HEADER_CONFIG;
  const { logo, fallbackText } = WHITE_LABEL_CONFIG.brand;
  const showImageLogo = isImageLogoPath(logo.src);

  return (
    <Link to={brand.link} className={className}>
      {showImageLogo ? (
        <img
          src={logo.src}
          alt={logo.alt}
          width={logo.width}
          height={logo.height}
          className={imageClassName}
        />
      ) : (
        <span className={textClassName}>{fallbackText}</span>
      )}
    </Link>
  );
}
